export const resizeImageFile = (file, maxWidth = 800, maxHeight = 800) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = e => {
      img.src = e.target.result;
    };

    img.onerror = error => reject(error);

    img.onload = () => {
      let { width, height } = img;
      const scale = Math.min(maxWidth / width, maxHeight / height, 1);
      width = Math.floor(width * scale);
      height = Math.floor(height * scale);

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
          blob => {
            // 명시적 메모리 해제
            img.src = '';
            reader.onload = null;
            reader.onerror = null;

            // canvas는 DOM에 붙은 게 아니라 해제 생략 가능하지만 명시적으로 null 처리 가능
            ctx.clearRect(0, 0, width, height);

            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('이미지 리사이징 실패'));
            }
          },
          file.type,
          1
      );
    };

    reader.readAsDataURL(file);
  });
};
